const notificationsKeys = {
  module: ['notifications'] as const,
  list: () => [...notificationsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...notificationsKeys.list(), filters] as const,
  details: (id: string) =>
    [...notificationsKeys.module, 'details', id] as const,
};

export default notificationsKeys;
